// frontend/src/components/builder/CreatePageModal.tsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from '@/components/ui/Modal';
import { FilePlus2, Library } from 'lucide-react';
import PageLibrary from './PageLibrary';
import { PageConfig } from '@/services/builderService';

interface CreatePageModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function CreatePageModal({ isOpen, onClose }: CreatePageModalProps) {
  const [view, setView] = useState<'options' | 'library'>('options');
  const navigate = useNavigate();

  const handleCreateNew = () => {
    navigate('/stitch/builder');
    onClose();
  };

  const handleUseExisting = () => {
    setView('library');
  };

  const handleSelectPage = (page: PageConfig) => {
    console.log("Selected page:", page);
    // TODO: Navigate to the builder with the selected page config loaded
    alert(`Selected page: ${page.name}. Loading this into the builder is the next step!`);
    onClose();
  };
  
  const handleBack = () => {
    setView('options');
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={view === 'options' ? "Create a New Page" : "Select an Existing Page"}>
      {view === 'options' && (
        <div className="flex flex-col space-y-4 mt-4">
          <button
            onClick={handleCreateNew}
            className="flex items-center p-4 border rounded-lg hover:bg-gray-50 text-left"
          >
            <FilePlus2 className="h-8 w-8 mr-4 text-intellend-green" />
            <div>
              <div className="font-semibold">Build a page from scratch</div>
              <div className="text-sm text-gray-500">Start with a blank canvas and add components.</div>
            </div>
          </button>
          <button
            onClick={handleUseExisting}
            className="flex items-center p-4 border rounded-lg hover:bg-gray-50 text-left"
          >
            <Library className="h-8 w-8 mr-4 text-gray-500" />
            <div>
              <div className="font-semibold">Use an existing page</div>
              <div className="text-sm text-gray-500">Select from a library of pre-built page templates.</div>
            </div>
          </button>
        </div>
      )}
      {view === 'library' && (
        <div>
            <PageLibrary onSelectPage={handleSelectPage} />
             <button onClick={handleBack} className="mt-4 text-sm text-gray-600 hover:underline">
                &larr; Back to options
            </button>
        </div>
      )}
    </Modal>
  );
}
